// filepath: /c:/Users/joanr/Desktop/pagina web de blog para adsense/mi-app/src/components/QuestionDivHome.js
import React from 'react';
import './QuestionDivHome.css';

const QuestionDivHome = () => {
  return (
    <div className="questiondivhome-container">
      <h2 className="questiondivhome-title">¿Por qué elegirnos?</h2>
      <p className="questiondivhome-description">
        En nuestra agencia, entendemos las necesidades del mercado local en Madrid. Por eso, ofrecemos soluciones personalizadas que te ayudarán a destacar frente a la competencia. Desde aumentar tu visibilidad online hasta implementar tecnología de vanguardia, nuestro equipo está aquí para llevar tu negocio al siguiente nivel.
      </p>
    </div>
  );
};

export default QuestionDivHome;